import {Text} from '@gravity-ui/uikit';
import {PropertyRow, formatDateToLocalDate} from '../../../../shared';
import {FundraiserDetailedModel} from '../../model';
import styles from './FundraiserAuditStatus.module.scss';

interface FundraiserAuditStatusProps {
  fundraiserData: FundraiserDetailedModel | null;
}

export const FundraiserAuditStatus = ({fundraiserData}: FundraiserAuditStatusProps) => {
  const formatDateOrDash = (date: string | null | undefined): string => {
    return date ? formatDateToLocalDate(date) : '-';
  };

  return (
    <div className={styles.auditContainer}>
      <Text variant={'subheader-2'} className={styles.title}>
        Аудит (статус сбора)
      </Text>

      <div className={styles.statusContainer}>
        <PropertyRow property={'Создан'} value={formatDateOrDash(fundraiserData?.createdAt)} />
        <PropertyRow property={'Опубликован'} value={formatDateOrDash(fundraiserData?.publishedAt)} />
        <PropertyRow property={'Отменен'} value={formatDateOrDash(fundraiserData?.cancelledAt)} />
        <PropertyRow property={'Средства собраны'} value={formatDateOrDash(fundraiserData?.amountCollectedAt)} />
        <PropertyRow property={'Завершен'} value={formatDateOrDash(fundraiserData?.completedAt)} />
      </div>
    </div>
  );
};
